import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteVenue = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (venueId: string) => {
      const url = `${sport}/o/${organizationId}/venues/${venueId}`;
      return await request(url, {
        method: "DELETE",
      });
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["venues"] }),
        queryClient.invalidateQueries({ queryKey: ["venues", sport, organizationId] }),
      ]);
    },
  });
};
